import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import pbc from "../../images/events/home.jpg";
import gsap from 'gsap';

export default function EventsSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (sectionRef.current) {
      gsap.fromTo(sectionRef.current,
        { y: 40, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.7, ease: 'power3.out' }
      );
    }
  }, []);

  return (
    <section ref={sectionRef} className="relative w-full h-[100vh] h-[100dvh] flex items-start justify-center overflow-hidden pt-32 md:pt-48">
      <div
        className="absolute inset-0 z-0 bg-cover"
        style={{
          backgroundImage: `url(${pbc})`,
          backgroundPosition: 'center 43%',
        }}
      >
        <div className="absolute inset-0 bg-slate-950/70" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center px-4">
        <h2 className="font-custom font-bold text-white md:text-8xl text-5xl">EVENTS</h2>
        <Link
          to="/events"
          className="w-fit px-5 py-2.5 bg-white text-slate-900 font-bold rounded-full hover:bg-mainBlue hover:text-white transition-all duration-300 hover:scale-105 font-custom mt-8 inline-block"
        >
          View All Events
        </Link>
      </div>
    </section>
  );
}
